/* eslint-disable import/first */
if (global) {
  // eslint-disable-next-line no-underscore-dangle
  global._babelPolyfill = false; // handle polyfill duplicate
}

import {
  getCountryCodeUtils as getCountryCode,
  getShopUtils as getShop,
  getPageUtils as getPage,
  getThemeUtils as getTheme,
  delayIfNeededUtils as delayIfNeeded,
  getCurrencyUtils as getCurrency,
  isCartPageUtils as isCartPage,
  isDraftThemeUtils as isDraftTheme,
  resetDataUtils as resetData,
  storeUTMDataUtils as storeUTMData,
  getShopConfigEndpointUtils as getShopConfigEndpoint,
  postDataUtils as postData,
  addShopifyFunctionsAttributeToCartUtils as addShopifyFunctionsAttributeToCart,
  removeShipProAndModifyCartIfNotEnabledUtils as removeShipProAndModifyCartIfNotEnabled,
  setIsDisabledUtils as setIsDisabled,
  customDisableProductTriggerUtils as customDisableProductTrigger,
  getPreviewModeUtils as getPreviewMode,
  getOrderIDUtils as getOrderID,
  setOrderIDUtils as setOrderID,
  extractFreegiftDiscountCodeFromURLUtils as extractFreegiftDiscountCodeFromURL,
  getWithExpiryUtils as getWithExpiry,
  setWithExpiryUtils as setWithExpiry,
  setWindowKeyUtils as setWindowKey,
  isFontSyncModeUtils as isFontSyncMode,
  extractMerchantDiscountCodeFromURLUtils as extractMerchantDiscountCodeFromURL,
  setExternalDiscountCodeForFunctionsUtils as setExternalDiscountCodeForFunctions,
  sleepUtils as sleep,
  loggerUtils as logger,
  getWidthBasedOnShopUtils as getWidthBasedOnShop,
} from './index-utils';

import { DEFAULT_SCREEN_WIDTH } from './app/components/constants';
const checkConfigAndInit = async () => {
  window.isMonkUpsellInstalled = true;
  resetData();
  await storeUTMData();

  let response = getWithExpiry('mr_config');
  if (!response) {
    response = await postData(getShopConfigEndpoint(), {
      theme: getTheme(),
      currency_code: getCurrency(),
      country_code: getCountryCode(),
      order_id: getOrderID(),
      source: 'config',
    });
    if (!response) {
      return;
    }
    // 60 seconds of caching
    setWithExpiry('mr_config', response, 60 * 1000);
  }

  const {
    is_enabled: isEnabled,
    isShopifyFunctionsEnabled,
    widgets,
    order_id,
  } = response;
  if (!isEnabled && !isDraftTheme()) {
    setIsDisabled(true);
    await addShopifyFunctionsAttributeToCart('');
    logger.log('na');
  } else {
    await addShopifyFunctionsAttributeToCart(order_id);
    setIsDisabled(false);

    // set the data for external discount codes in functions
    if (isShopifyFunctionsEnabled) {
      setExternalDiscountCodeForFunctions();
    }

    // initializeErrorMonitoring({ orderID: getOrderID(), shopURL: getShop() });

    // custom case for stores to not load in case of homepage
    if (
      !isCartPage() &&
      getPage() !== 'product' &&
      getPage() !== 'collection' &&
      [
        'withinus.myshopify.com',
        'withinus-co.myshopify.com',
        'zulu-athletic.myshopify.com',
        'homeofposters.myshopify.com',
        'alamea-shop.myshopify.com',
        'megalashacademy.myshopify.com',
        'longevitybox.myshopify.com',
        'skincaresite.myshopify.com',
        'wildnest-camper.myshopify.com',
        'naya-glow.myshopify.com',
        'theputchi.myshopify.com',
        'alamea-shop.myshopify.com',
        'bowtiedfarmer.myshopify.com',
        'barber-plug-supply-co.myshopify.com',
        'deichbrise-onlineshop.myshopify.com',
        'sbmlimited.myshopify.com',
        'yoga-studio-store.myshopify.com',
        'noxsport.myshopify.com',
        'the-space-lines.myshopify.com',
        'erobold-store.myshopify.com',
        'glamazon-6341.myshopify.com',
        'a-girls-gotta-spa.myshopify.com',
        'zenzsual.myshopify.com',
        'zenzual-woman.myshopify.com',
        'tu-salud-intima-mexico.myshopify.com',
        'kacperglobalshoes.myshopify.com',
        'vonabride.myshopify.com',
        'dr-ashley.myshopify.com',
      ].includes(getShop())
    ) {
      return;
    }

    if (
      !isCartPage() &&
      ['nuethix.myshopify.com', 'xyzskincare.myshopify.com'].includes(getShop())
    ) {
      return;
    }

    const shopSpecificWidth = getWidthBasedOnShop(
      getShop(),
      DEFAULT_SCREEN_WIDTH.width,
    );
    DEFAULT_SCREEN_WIDTH.width = shopSpecificWidth;

    // delay loading of app for some stores
    await delayIfNeeded();

    const {
      embedded: { cartIcon: cartIconConfig },
      cartPageDiscountConfig,
      isPopupEnabled,
      isVDAboveATCEnabled,
      isProductAddonsAboveATCEnabled,
      isCVBEnabled,
      isEmbeddedEnabled,
      isAutoFreegiftEnabled,
      isDiscountCodeEnabled,
      isDPSEnabled,
      isSubscriptionUpsellEnabled,
      isShipProEnabled,
      productFormSelector,
      buttonSelectors,
      cartListener: cartListenerConfig,
    } = response;

    if (order_id !== getOrderID() && order_id) {
      logger.serverInfoLog(`new session order id ${order_id}`, {
        mrOrderID: order_id,
        shopURL: getShop(),
      });
    }

    setOrderID(order_id);

    // below functions are used to get discount codes from url so that it can be auto applied
    extractFreegiftDiscountCodeFromURL();
    extractMerchantDiscountCodeFromURL();

    setWindowKey('mrUpsellConfig', response);
    // const isPopupEnabled = true;
    // const isCVBEnabled = true;
    // const isEmbeddedEnabled = true;
    // const isAutoFreegiftEnabled = true;
    // const isDiscountCodeEnabled = true;

    const isAnyFeatureEnabled =
      isPopupEnabled ||
      isCVBEnabled ||
      isEmbeddedEnabled ||
      isAutoFreegiftEnabled ||
      isDPSEnabled ||
      isSubscriptionUpsellEnabled ||
      isShipProEnabled;

    const isInteceptorEnabled =
      isAnyFeatureEnabled &&
      (cartPageDiscountConfig.isEnabled || window.mrForceEnable);

    const modulesToBeImported = [];
    const moduleNames = [];
    if (isAnyFeatureEnabled) {
      modulesToBeImported.push(import('./configureStore'));
      modulesToBeImported.push(import('./cartDiscount'));
      moduleNames.push('configureStore');
      moduleNames.push('cartDiscountModule');
    }
    if (isFontSyncMode()) {
      modulesToBeImported.push(import('./features/fontSyncModule'));
      moduleNames.push('fontSyncModule');
    }
    if (isLoadPreviewModule()) {
      modulesToBeImported.push(import('./preview'));
      moduleNames.push('previewModule');
    }
    if (isInteceptorEnabled) {
      modulesToBeImported.push(import('./interceptor'));
      moduleNames.push('interceptorModule');
    }
    if (isPopupEnabled) {
      modulesToBeImported.push(import('./features/popupModule'));
      moduleNames.push('popupModule');
    }
    if (isShipProEnabled) {
      modulesToBeImported.push(import('./features/shipProModule'));
      moduleNames.push('shipProModule');
    }
    if (isCVBEnabled) {
      modulesToBeImported.push(import('./features/cvbModule'));
      moduleNames.push('cvbModule');
    }
    if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
      modulesToBeImported.push(import('./features/subscriptionUpsellModule'));
      moduleNames.push('subscriptionUpsellModule');
    }
    if (isDPSEnabled) {
      modulesToBeImported.push(import('./features/dpsModule'));
      moduleNames.push('dpsModule');
    }
    if (isEmbeddedEnabled) {
      modulesToBeImported.push(import('./features/embeddedModule'));
      moduleNames.push('embeddedModule');
    }
    if (isAutoFreegiftEnabled) {
      modulesToBeImported.push(import('./features/autoAddFreegift'));
      moduleNames.push('autoAddFreegiftModule');
    }
    if (isDiscountCodeEnabled) {
      modulesToBeImported.push(import('./features/discountCodeModule'));
      moduleNames.push('discountCodeModule');
    }
    if (isAnyFeatureEnabled) {
      modulesToBeImported.push(import('./features/shopEventModule'));
      moduleNames.push('shopEventModule');
      if (isShopifyFunctionsEnabled) {
        modulesToBeImported.push(import('./features/shopifyFunctionsDiscount'));
        modulesToBeImported.push(import('./features/storeFrontCart'));
      }
    }
    const importedModules = await Promise.all(modulesToBeImported);

    let store;
    let storeModule;
    let cartDiscountModule;
    let fontSyncModule = null;
    let previewModule = null;
    let interceptorModule = null;
    let popupModule = null;
    let cvbModule = null;
    let shipProModule = null;
    let subscriptionUpsellModule = null;
    let dpsModule = null;
    let embeddedModule = null;
    let shopEventModule = null;
    let autoAddFreegiftModule = null;

    moduleNames.forEach((moduleName, index) => {
      if (moduleName === 'configureStore') {
        storeModule = importedModules[index];
      }
      if (moduleName === 'cartDiscountModule') {
        cartDiscountModule = importedModules[index];
      }
      if (moduleName === 'fontSyncModule') {
        fontSyncModule = importedModules[index];
      }
      if (moduleName === 'previewModule') {
        previewModule = importedModules[index];
      }
      if (moduleName === 'interceptorModule') {
        interceptorModule = importedModules[index];
      }
      if (moduleName === 'popupModule') {
        popupModule = importedModules[index];
      }
      if (moduleName === 'shipProModule') {
        shipProModule = importedModules[index];
      }
      if (moduleName === 'cvbModule') {
        cvbModule = importedModules[index];
      }
      if (moduleName === 'subscriptionUpsellModule') {
        subscriptionUpsellModule = importedModules[index];
      }
      if (moduleName === 'dpsModule') {
        dpsModule = importedModules[index];
      }
      if (moduleName === 'embeddedModule') {
        embeddedModule = importedModules[index];
      }
      if (moduleName === 'autoAddFreegiftModule') {
        autoAddFreegiftModule = importedModules[index];
      }
      if (moduleName === 'shopEventModule') {
        shopEventModule = importedModules[index];
      }
    });
    if (isAnyFeatureEnabled) {
      customDisableProductTrigger();
      store = storeModule.default({});
    }

    if (isFontSyncMode()) {
      await fontSyncModule.checkAndLoadFontSync();
      logger.log('font-sync enabled');
    }

    if (isLoadPreviewModule()) {
      await previewModule.checkAndLoadPreview();
      logger.log('preview enabled');
    }

    if (isInteceptorEnabled) {
      interceptorModule.registerHTTPInterceptor({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAutoFreegiftEnabled,
        isShipProEnabled,
        widgets,
        cartListenerConfig,
      });
    }

    if (isPopupEnabled) {
      popupModule.setStore(store);
      popupModule.init();
      logger.log('popup enabled');

      if (isCartPage()) {
        popupModule.getOfferAndDisplayOnCartPageInit();
      }
    }

    if (isShipProEnabled) {
      logger.log('shipPro enabled store');
      shipProModule.setStore(store);
    }

    if (isCVBEnabled) {
      cvbModule.setStore(store);
      logger.log('cvb enabled');
    }

    if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
      subscriptionUpsellModule.setStore(store);
      logger.log('subscription enabled');
    }

    if (isEmbeddedEnabled) {
      embeddedModule.setStore(store);
      embeddedModule.init({
        config: response,
        isCVBEnabled,
        widgets,
        productFormSelector,
      });
      logger.log('embedded enabled');
    }
    if (isAutoFreegiftEnabled) {
      autoAddFreegiftModule.init({
        config: {
          cartPageDiscountConfig: response.cartPageDiscountConfig,
          isDiscountCodeEnabled: response.isDiscountCodeEnabled,
          widgets: response.widgets,
        },
        productFormSelector,
      });
    }

    if (isDiscountCodeEnabled) {
      logger.log('discount code enabled');
    }

    if (isAnyFeatureEnabled) {
      shopEventModule.init({
        isPopupEnabled,
        isVDAboveATCEnabled,
        isProductAddonsAboveATCEnabled,
        isAnyFeatureEnabled,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAutoFreegiftEnabled,
        isShipProEnabled,
        cartIconConfig,
        store,
        widgets,
        buttonSelectors,
        productFormSelector,
      });

      if (isCartPage()) {
        if (isCVBEnabled) {
          await cvbModule.checkCVBAndDisplay({
            retryContainerCreation: true,
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        }
        if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
          subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
            widgets,
          });
        }

        if (isShipProEnabled) {
          logger.log('shipPro enabled');
          shipProModule.checkShippingProtectionAndDisplay({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        } else {
          removeShipProAndModifyCartIfNotEnabled({ isRefresh: true });
        }
      }

      if (isDPSEnabled) {
        dpsModule.checkOffer();
      }

      const delayed = async () => {
        await sleep(1500);
        cartDiscountModule.checkAndUpdateCartDiscount({
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      };
      delayed();

      if (['chronoxis.myshopify.com'].includes(getShop())) {
        const customEventsModule = await import('./features/customEvents/customEventsReceiver');
        customEventsModule.init(getShop());
      }
    }
  }
  window.isMonkUpsellInitDone = true;
  logger.log('init done');
};

export function isLoadPreviewModule() {
  if (getPreviewMode() === 'true') {
    return true;
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  const isPreviewMode = urlSearchParams.get('mrpm');
  if (isPreviewMode) {
    return true;
  }

  return false;
}

checkConfigAndInit();

// const initializeErrorMonitoring = ({ orderID, shopURL }) => {
//   try {
//     const bugsnagKey = getBugsnagKey();
//     if (bugsnagKey) {
//       Bugsnag.start({
//         apiKey: 'd4542c16d530fa1114d896371c046ea6',
//         autoDetectErrors: false,
//         autoTrackSessions: false,
//         hostname: shopURL,
//         user: {
//           id: orderID,
//         },
//       });
//       logger.log('bugsnag initialized');
//     }
//   } catch (e) {
//     logger.log(e);
//   }
// };
